export enum DebtTableStatus {
  CANCELLED = 'cancelled',
  PENDING = 'pending',
}
